<template>
	<div class="container">
		<van-sticky>
		<div class="nav_h5">
			<div class="nav_box_h5">
				<div class="left">
					<img src="../../assets/img_public/logo.png" @click="goIndex" />
				</div>
				<div class="lang_box" @click="goCN">CN</div>
				<div class="search_box" @click="goSearch">
					<img src="../../assets/img_public/icon_search.webp" style="width: 26px;" />
				</div>
				<div class="right">
					<img v-if="!isShow" src="../../assets/img_public/icon_list.webp" style="width: 26px;" @click="showSlide" />
					<img v-else src="../../assets/img_public/icon_list_close.webp" style="width: 26px;" @click="showSlide" />
				</div>
			</div>
			<!--折叠导航-->
			<div class="slide_box" :class="isShow ? 'height-slide' : ''" :border="false">
				<div style="padding: 16px 0 16px 0;border-bottom: 1px solid #E3E1E6;font-size: 18px;font-weight: bold;" @click="goIndex">Home</div>
				<van-collapse v-model="activeName" accordion>
					<van-collapse-item
						v-for="(value, index) in navData"
						:key="index"
						:name="value.title"
						:border="false"
					>
							<template #right-icon>
								<van-icon :name="activeName == value.title ? 'minus' : 'plus'" size="18px" color="#999999" />
							</template>
							<template #title>
								<div class="title">{{ value.title }}</div>
							</template>
							<div v-if="value.title != $t('nav.text5')">
								<div v-for="(value2, index2) in value.children" :key="index2" class="text" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
							</div>
							<div v-else>
								<div v-for="(value2, index2) in value.children.cate_list" :key="index2" class="text" @click="oneNavClick2(value2)">{{ value2.title }}</div>
							</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			<!--折叠导航-->
		</div>
		</van-sticky>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	props: ['pageName'],
	data() {
		return {
			//移动导航
			navData: [],
			isShow: false,
			pagename: this.pageName,
			activeName: '',
			lang: sessionStorage.getItem('lang')
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			let data = JSON.parse(sessionStorage.getItem('navList'));
			data.forEach((value, index) => {
				if(value.title != that.$t('nav.text6')) {
					that.navData.push(value);
				}
			});
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击跳转CN
		goCN() {
			window.location.href = 'https://coretests.cn/';
		},
		oneNavClick2(value) {
			if(this.$route.path != '/product-list.html') {
				this.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}else {
				this.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		//一级导航点击
		oneNavClick(value, value2) {
			let that = this;
			if(that.$route.path != value.url) {
				that.isShow = false;
				if(value.route == 'JobList') {
					if(that.$route.name === value.route) {
						that.$router.push({ path: '/job/'+value.url });
						window.location.reload();
					}else {
						that.$router.push({ path: '/job/'+value.url });
					}
				}else {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
								setTimeout(() => {
									window.location.reload();
								}, 300);
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}
			}else {
				window.location.reload();
			}
		},
		//显示/隐藏导航
		showSlide() {
			let that = this;
			that.isShow = !that.isShow;
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.isShow = false;
				that.$router.push({ path: '/', });
			}else {
				window.location.reload();
			}
		},
		//跳转搜索
		goSearch() {
			let that = this;
			if(that.$route.path != '/search.html') {
				that.isShow = false;
				that.$router.push({ path: '/search.html', });
			}
		},
		//跳转导航
		navHandle(value) {
			let that = this;
			if(that.$route.path != value.url) {
				that.isShow = false;
				that.$router.push({ path: value.url, });
			}
		},
	}
}
</script>

<style lang="less" scoped>
.slide_box {
	position: absolute;
	z-index: 2;
	width: 100%;
	background-color: #ffffff;
	max-height: 0;
	transition: max-height 0.75s;
	overflow: hidden;
	height: 100vh;
	background-color: #ffffff;
	padding: 0px 16px 0 16px;
	.van-collapse{
		padding: 10px 0 0 0;
		.van-collapse-item{
			padding: 16px 0 0 0;
			border-bottom: 1px solid #E3E1E6;
		}
	}
	.title{
		padding-bottom: 18px;
		font-size: 18px;
		font-weight: bold;
	}
	.text{
		padding-bottom: 15px;
		font-size: 18px;
		color: #666666;
	}
	div.actived{
		background-color: #f5f8fa;
		color: #0B318F;
	}
}
.height-slide {
	max-height: 1000px;
}
</style>
<style scoped>
>>> .slide_box .van-hairline--top-bottom::after, >>> .slide_box .van-hairline-unset--top-bottom::after{
	border: none;
}
>>> .slide_box .van-cell, >>> .slide_box .van-collapse-item__content{
	padding: 0;
}
>>> .slide_box .van-cell--clickable{
	background-color: transparent;
}
/*导航*/
.nav_box_h5 {
	height: 60px;
	display: flex;
	align-items: center;
	position: relative;
	z-index: 1;
	background-color: #ffffff;
	border-bottom: 1px solid #F7F6F9;
}

.nav_box_h5 .left {
	flex: 1;
	display: flex;
	align-items: center;
	padding-left: 16px;
	height: 100%;
}

.nav_box_h5 .right {
	width: auto;
	padding-right: 16px;
}

.nav_box_h5 .left img {
	width: 110px;
	height: auto;
	position: relative;
}

.nav_box_h5 .right img {
	width: 24px;
	height: auto;
}

.nav_box_h5 .search_box{
	position: absolute;
	right: 58px;
}
.nav_box_h5 .lang_box{
	position: absolute;
	line-height: 1;
	right: 100px;
	padding: 7px 8px 2px 8px;
	border: 1px solid #ECE7E8;
	border-radius: 10px;
	color: #A50073;
}

</style>
